window.addEventListener(
    'CookiebotOnConsentReady',
    function () {
        if (Cookiebot.consent.marketing && Cookiebot.consent.statistics) {
            var script = document.createElement('script');
            script.src = 'https://cdn.optimizely.com/js/24692250175.js';
            document.head.appendChild(script);
        }
    },
    false,
);
